
import {Component, ElementRef, HostListener, Input} from '@angular/core';

@Component({
  selector: 'hub-help-tooltip',
  imports: [],
  template: `
    <span class="help-tooltip">
      <button type="button" class="help-trigger" (click)="toggle($event)" [attr.aria-expanded]="open" [attr.aria-label]="label">?</button>
      @if (open) {
        <span class="help-panel" role="tooltip">{{ text }}</span>
      }
    </span>
    `,
  styles: [`
    .help-tooltip {
      position: relative;
      display: inline-flex;
      align-items: center;
    }

    .help-trigger {
      display: inline-grid;
      place-items: center;
      width: 1rem;
      height: 1rem;
      border: 0;
      border-radius: 999px;
      padding: 0;
      background: #e2e8f0;
      color: #172033;
      cursor: pointer;
      font: inherit;
      font-size: .75rem;
      font-weight: 700;
      line-height: 1;
    }

    .help-trigger:hover,
    .help-trigger:focus-visible {
      background: #cbd5e1;
      outline: none;
    }

    .help-panel {
      position: absolute;
      z-index: 30;
      top: calc(100% + .35rem);
      left: 0;
      width: max-content;
      max-width: min(22rem, calc(100vw - 2rem));
      padding: .65rem .75rem;
      border: 1px solid #cbd5e1;
      border-radius: .2rem;
      background: #172033;
      color: #fff;
      box-shadow: 0 10px 28px rgba(15, 23, 42, .18);
      font-size: .86rem;
      font-weight: 500;
      line-height: 1.35;
      white-space: pre-line;
    }
  `]
})
export class HelpTooltipComponent {
  @Input() text = '';
  @Input() label = 'Help';
  open = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {
  }

  toggle(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.open = !this.open;
  }

  @HostListener('document:click', ['$event'])
  closeFromOutside(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.open = false;
    }
  }

  @HostListener('keydown.escape')
  closeFromEscape(): void {
    this.open = false;
  }
}
